import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getUnreadPollCount } from '../../../polls/functions';
import { getUnreadCount } from '../../functions';
/**
 * Implements a React {@link Component} which displays a count of the number of
 * unread chat messages.
 *
 * @augments Component
 */
class ChatCounterMobile extends Component {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { _isOpen, _count, customClass } = this.props;
        if (_count === undefined || _count < 1) {
            return React.createElement(React.Fragment, null);
        }
        return (React.createElement("span", { className: `badge-round-mobile${!_isOpen && _count > 0 ? ' not-empty' : ''} ${customClass ?? ''}${_count > 9 ? ' more-than-9' : ''}` }, !_isOpen && (React.createElement("span", null, _count > 9 ? '9+' : _count))));
    }
}
/**
 * Maps (parts of) the Redux state to the associated {@code ChatCounterMobile}'s
 * props.
 *
 * @param {Object} state - The Redux state.
 * @private
 * @returns {{
 *     _count: number
 * }}
 */
function _mapStateToProps(state) {
    const { isOpen } = state['features/chat'];
    return {
        _count: getUnreadCount(state) + getUnreadPollCount(state),
        _isOpen: isOpen
    };
}
export default connect(_mapStateToProps)(ChatCounterMobile);
